import { Component } from '@angular/core';

@Component({
    selector: 'lib-verified-message',
    templateUrl: './verified-message.component.html',
    styleUrls: ['./verified-message.component.scss'],
    standalone: false
})
export class VerifiedMessageComponent {}
